/**
 * Utility function to convert a string that is loaded via Vite's import.meta.env to a boolean.
 *
 * @param {string | undefined} value
 * @returns {boolean}
 */
export const toBool = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }
  const normalizedValue = value.trim().toLowerCase();
  return normalizedValue === 'true' || normalizedValue === '1' || normalizedValue === 'yes';
};
